import React from 'react';

function Qualification() {
    return (
      <section className="bd-qulafication__area section-space theme-bg-secondary">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6">
              <div className="section__title-wrapper text-center section__title-space">
                <div className="section__title-wrapper">
                  <span className="section__subtitle">Education</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center justify-content-center wow fadeInUp" data-wow-delay=".3s">
            <div className="tab-content wow fadeInUp" id="nav-tabContent" data-wow-delay=".3s" data-wow-duration="1s">
              <div
                className="tab-pane fade show active"
                id="nav-experience"
                role="tabpanel"
                aria-labelledby="nav-experience-tab"
              >
                <div className="row g-5">
                  <div className="col-xl-6 col-lg-6">
                    <div className="faq__style">
                      <div className="bd__faq">
                        <div className="accordion" id="accordionExampleFour">
                          <div className="accordion-item">
                            <h5 className="accordion-header" id="headingOne">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                Master of Computer Applications (2018-2020)
                              </button>
                            </h5>
                            <div
                              id="collapseOne"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionExampleFour"
                            >
                              <div className="accordion-body">
                                <span className="qualification__meta">
                                  Nehru Institute of IT and Management Coimbatore
                                </span>
                                <h6 className="qualification__rating">CGPA- 7.4</h6>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <h5 className="accordion-header" id="headingTwo">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                B. Sc (Computer Science) (2015 -2018)
                              </button>
                            </h5>
                            <div
                              id="collapseTwo"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingTwo"
                              data-bs-parent="#accordionExampleFour"
                            >
                              <div className="accordion-body">
                                <span className="qualification__meta">Sri Kaliswari College, Sivakasi</span>
                                <h6 className="qualification__rating">69%</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-6">
                    <div className="faq__style">
                      <div className="bd__faq">
                        <div className="accordion" id="accordionExampleFour2">
                          <div className="accordion-item">
                            <h5 className="accordion-header" id="headingThree">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-expanded="true"
                                aria-controls="collapseThree"
                              >
                                +2 (Computer Science) (2015)
                              </button>
                            </h5>
                            <div
                              id="collapseThree"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingThree"
                              data-bs-parent="#accordionExampleFour2"
                            >
                              <div className="accordion-body">
                                <span className="qualification__meta">Muslim Higher Secondary School, Sivakasi</span>
                                <h6 className="qualification__rating">51%</h6>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <h5 className="accordion-header" id="headingFour">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseFour"
                                aria-expanded="true"
                                aria-controls="collapseFour"
                              >
                                +10th Grade (2013)
                              </button>
                            </h5>
                            <div
                              id="collapseFour"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingFour"
                              data-bs-parent="#accordionExampleFour2"
                            >
                              <div className="accordion-body">
                                <span className="qualification__meta">
                                  S. H. N. V Higher Secondary School, Sivakasi
                                </span>
                                <h6 className="qualification__rating">81%</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

  );
};

export default Qualification;
